// Sample Object for three level filter. First level is Make, second is model and third is year. Last/Third filter should be an array.
// First value is Make, second is model and this is year
let makeObject = {
  Acura: {
    ILX: ["2024","2023","2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    Integra: ["2025","2024","2023"],
    MDX: ["2024","2023","2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    RDX: ["2025", "2024","2023","2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    TL: ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    RL: ["2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    TLX: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    TSX: ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    ZDX: ["2013", "2012", "2011", "2010"],
  },
  Audi: {
    "A3 Convertible": ["2019", "2018", "2017", "2016", "2015"],
    "A3 E Tron": ["2018", "2017", "2016"],
    "A3 Hatchback": ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "A3 Sedan": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "A4 Allroad": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "A4 Cabriolet": ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "A4 Sedan": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    A5: ["2023", "2022", "2021", "2020", "2019", "2018"],
    "A5 Cabriolet": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010"],
    "A5 Coupe": ["2024", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "A5 Sportback": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "A6 Allroad": ["2025", "2024", "2023", "2022", "2021", "2020", "2016", "2015","2014", "2013"],
    "A6 Sedan": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    "A7": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    "E Tron": ["2024", "2023", "2022", "2021"],
    Q3: ["2025","2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012"],
    Q5: ["2025","2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010"],
    "Q5 Sportback": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "Q7": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Rs3: ["2019", "2018", "2017"],
    "RS4 Convertible": ["2008"],
    S4: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "S4 Convertible": ["2009", "2008", "2007", "2006", "2005", "2004"],
    "S5 Sportback": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "SQ5": ["2024", "2023", "2022", "2021", "2020"],
    "SQ5 Sportback": ["2025"],
    "S6 Sedan": ["2018", "2017", "2016", "2015", "2014", "2013"],
    "Tt Mk2 Coupe": ["2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008"],


  },
  BMW: {
    "1 Series": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "2 Series": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014"],
    "3 Series": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
    "3 Series Convertible": ["1999", "1998", "1997"],
    "4 Series": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014"],
    "4 Series Convertible": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014"],
    "4 Series Coupe": ["2020", "2019", "2018", "2017", "2016", "2015","2014"],
    "4 Series Gran Coupe": ["2025", "2024", "2023", "2022"],
    "5 Series": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1985"],
    "5 Series Gran Turismo": ["2017", "2016", "2015","2014", "2013", "2012", "2011", "2010"],
    "5 Series PHEV": ["2023", "2022", "2021", "2020", "2019", "2018"],
    "6 Series": ["2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "6 Series Gran Turismo": ["2019", "2018"],
    "7 Series": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009"],
    "8 Series": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
    "I Series": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014"],
    "X Series": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Z Series": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
  
  },
  Buick: {
    "Enclave 7 Passenger Seating": ["2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Enclave 8 Passenger Seating": ["2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    Encore: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015","2014", "2013"],
    "Encore Gx": ["2023", "2022", "2021", "2020"],
    Envision: ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    Envista: ["2024"],
    Lacrosse: ["2016", "2015","2014", "2013", "2012"],
    Regal: ["2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974"],  
    "Regal Sportback": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "Regal Tourx": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    Rendezvous: ["2007", "2006", "2005", "2004", "2003", "2002"],
    Verano: ["2017", "2016", "2015","2014", "2013", "2012"],
  },
  Cadillac: {
    Ct4: ["2024", "2023", "2022", "2021", "2020"],
    "Ct4 V": ["2024"],
    Ct5: ["2024", "2023", "2022", "2021", "2020"],
    "Ct5 V": ["2024"],
    Cts: ["2011"],
    "DeVille Convertible": ["1965"],
    Escalade: ["2020", "2019", "2018", "2017", "2016", "2015","2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Suv Lyriq": ["2024"],
    Xt4: ["2024", "2023", "2022", "2021", "2020", "2019"],
    Xt5: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    Xt6: ["2024", "2023", "2022", "2021", "2020"],
  },
  Chevrolet: {
    
"150 / 210 Series": ["1957", "1956", "1955", "1954", "1953"],
Avalanche: ["2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
Aveo: ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
"Bel Air": ["1958", "1957", "1956", "1955", "1954", "1953", "1952", "1951", "1950"],
"Blazer (Crossover)": ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
"Blazer (Full-size)": ["1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969"],
"Bolt EV/EUV": ["2023", "2022", "2021", "2020", "2019", "2018", "2017"],
Camaro: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966", "1967"],
Caprice: ["1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966"],
"C10/C/K Pickup Truck": ["1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967"],
"Chevelle / Malibu": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966", "1965", "1964"],
Cobalt: ["2010", "2009", "2008", "2007", "2006", "2005"],
Colorado: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
Corvette: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966", "1965", "1964", "1963", "1962", "1961", "1960", "1959", "1958", "1957", "1956", "1955", "1954", "1953"],
Cruze: ["2010", "2009", "2008", "2007", "2006", "2005"],
"El Camino": ["1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966", "1965", "1964", "1963", "1962", "1961", "1960", "1959"],
Equinox: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
"Impala Classic": ["1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966", "1965", "1964", "1963", "1962", "1961", "1960", "1959", "1958"],
"Impala FWD": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
"Impala SS": ["1996", "1995", "1994"],
"Monte Carlo": ["2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970"],
"Nova / Chevy II": ["1979", "1978", "1977", "1976", "1975", "1974", "1973", "1972", "1971", "1970", "1969", "1968", "1967", "1966", "1965", "1964", "1963", "1962"],
"S10 Blazer": ["2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983"],
"S10 Pickup": ["2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982"],
"Silverado / Sierra": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988"],
Sonic: ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
Spark: ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
"Tahoe / Suburban / Yukon": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995"],
"TrailBlazer (Mid-size)": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
"Trailblazer (Crossover)": ["2025", "2024", "2023", "2022", "2021"],
Trax: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
Traverse: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
Volt: ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"]



  },


  Chrysler: {
   "300": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
  " 300c": ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
   "301": ["2005"],
  },

  Dodge: {
    Challenger: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    Dart: ["2016", "2015", "2014", "2013"],
    Charger: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    Durango: ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Grand Caravan": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    Journey: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
  },
  Fiat: {
  "500c": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
  },



  Ford: {
    Bronco: ["2024", "2023", "2022", "2021"],
    "Bronco Sport": ["2024", "2023", "2022", "2021"],
    "Crown Victoria": ["2002", "2001", "2000", "1999", "1998"],
    Ecosport: ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    Edge: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Escape: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006","2005", "2004", "2003", "2002","2001"],
    Explorer: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Explorer Sport Trac": ["2010", "2009", "2008", "2007", "2006","2005", "2004", "2003", "2002","2001"],
    "F150": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    "F150 F250": ["2014", "2013"],
    "F150 Lightning": ["2024"],
    "F250": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Fiesta Hatchback": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Fiesta Sedan": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Five Hundred": ["2007", "2006", "2005"],
    Flex: ["2013", "2012", "2011"],
    Focus: ["2011"],
    "Focus 4dr Sedan": ["2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Focus Electric": ["2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Focus Hatchback": ["2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Focus RS": ["2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Focus Sedan": ["2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Focus ST": ["2018", "2017", "2016", "2015", "2014", "2013"],
    Fusion: ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Fusion Energi": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    Maverick: ["2026", "2025", "2024", "2023", "2022"],
    Mustang: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Ranger  Supercab": ["2024", "2023", "2022", "2021", "2020", "2019"],
    "Ranger  Supercrew": ["2024", "2023", "2022", "2021", "2020", "2019"],
    "Super Duty F250": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "Super Duty F250 350 450": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "Super Duty F350": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Super Duty F450": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Transit Connect": ["2024", "2023", "2022", "2021", "2020"],

  },
  GMC: {
    "Acadia 6 Passenger Seating": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "Acadia 7 Passenger Seating": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Acadia 8 Passenger Seating": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Canyon: ["2021", "2020", "2019", "2018", "2017", "2016"],
    "Sierra 1500": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    "Sierra 2500 Hd": ["2024", "2023", "2022", "2021", "2020", "2019"],
    "Sierra 2500 Hd 3500": ["2024", "2023", "2022", "2021", "2020", "2019"],
    Terrain: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    Yukon: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "Yukon Hybrid": ["2013", "2012", "2011", "2010", "2009", "2008"],
    "Yukon Xl 6 Passenger Seating": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Yukon Xl 7 Passenger Seating": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],

  },
  Honda: {
    "9 Era Civic Sedan": ["2015", "2014", "2013", "2012", "2011"],
    Accord: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
  "Accord Coupe": ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
  "Accord Crosstour": ["2012", "2011", "2010"],
  Civic: ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
  "Civic Coupe": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
  "Civic Hatchback": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
  "Civic Sedan": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
  "Cr V": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
  Crosstour: ["2015", "2014", "2013", "2012"],
  Fit: ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
  Hrv: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
  Odyssey: ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
  Passport: ["2022", "2021", "2020", "2019"],
  Pilot: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
  Ridgeline: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
  },
  
  Hyundai: {
    Elantra: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    Genesis: ["2014", "2013", "2012", "2011", "2010", "2009"],
    "Genesis Coupe": ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "Loniq Plug-in Hybrid": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    Kona: ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "Kona Electric": ["2024", "2023", "2022", "2021", "2020"],
   "Loniq EV": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
   "Loniq Hybrid": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    Palisade: ["2024", "2023", "2022", "2021", "2020"],
   "Santa Cruz": ["2024", "2023", "2022"],
   Santafe: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
   Sonata: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000"],
   "Sonata Hybrid": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
   "Tucson Hybrid": ["2024"],
   "Tucson Phev": ["2024", "2023", "2022"],
   "Veloster N": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
   Venue: ["2024", "2023", "2022", "2021", "2020"],
   Veracruz: ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
  },
  Infiniti: {
    Fx35: ["2012", "2011", "2010", "2009", "2008"],
    G35x: ["2008", "2007", "2006", "2005", "2004", "2003"],
    G37: ["2013", "2012", "2011", "2010", "2009", "2008"],
    "G37 Coupe": ["2013", "2012", "2011", "2010", "2009", "2008"],
    M37: ["2013", "2012", "2011"],
    M45: ["2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    Q40: ["2015", "2014", "2013", "2012", "2011", "2010"],
    Q50: ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    Q51: ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    Q60: ["2022", "2021", "2020", "2019", "2018", "2017"],
    Qx50: ["2017", "2016", "2015", "2014"],
    Qx80: ["2018", "2017", "2016", "2015", "2014"],
  },
 Jeep: {
    Cherokee: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    Commander: ["2010", "2009", "2008", "2007", "2006"],
    Compass: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    Gladiator: ["2025", "2024", "2023", "2022", "2021", "2020"],
    "Grand Cherokee": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Grand Cherokee I": ["2024", "2023", "2022", "2021"],
    "Grand Cherokee Srt 7": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Grand Wagoneer": ["2024", "2023", "2022"],
    Hummer: ["2012", "2011", "2010", "2009", "2008"],
    Patriot: ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    Renegade: ["2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    Wagoneer: ["2024", "2023", "2022"],
    Wrangler: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987"],
  },
  Jaguar: {
    XF: ["2011", "2010", "2009"],
  },
Kia: {
    Carnival: ["2024", "2023", "2022"],
    Forte: ["2024", "2023", "2022", "2021", "2020", "2019"],
    K5: ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "Niro Ev": ["2022", "2021", "2020", "2019", "2018", "2017"],
    Rio: ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "Rio 5 Door": ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    Seltos: ["2024", "2023", "2022", "2021"],
    Sorento: ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    Soul: ["2019", "2018", "2017", "2016", "2015", "2014"],
    Sportage: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Sportage Hybrid": ["2024", "2023", "2022"],
    "Sportage Plug-in Hybrid": ["2024", "2023", "2022"],

  },
    "Land Rover": {
    Defender: ["2024", "2023", "2022", "2021", "2020"],
    Discovery: ["2019", "2018", "2017", "2016", "2015"],
    "Range Rover Sport": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
  },

  Lexus: {
    Es: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    Gs: ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    Gx: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    Is: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Ls: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    Lx: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    Nx: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    Rx: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    Ux: ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    
    
     

    
  },
 
  Mazda: {
    "3": ["2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003"],
    "3 Hatch": ["2024", "2023", "2022", "2021", "2020", "2019"],
    "3 Sedan": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "6": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
    Cx3: ["2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    Cx30: ["2024", "2023", "2022", "2021", "2020"],
    Cx5: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    Cx9: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
  },



  "Mercedes Benz": {
    "AMG GT (Coupe/Roadster)": ["2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "B-Class": ["2017", "2016", "2015","2014"],
    "C-Class": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994"],
   "CLA-Class": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
   "CLS-Class": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    "E-Class": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986"],
   "GLA-Class": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
   "GLB-Class": ["2025", "2024", "2023", "2022", "2021", "2020"],
   "GLC-Class": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
   "GLE-Class (formerly M-Class)": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
   "GLS-Class (formerly GL)": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
   "G-Class": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
   "M-Class / GLE-Class (U.S.)": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
   "SL-Class": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990"],
   "SLK/SLC-Class": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
   "S-Class": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992", "1991", "1990", "1989", "1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981"],
  },


  // "Mercedes Benz": {
  //   "A 220": ["2022", "2021", "2020", "2019"],
  //   "Amg A 35 Base": ["2021", "2020"],
  //   "C W204": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
  //   "C W205": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
  //   "C250 Coupe C204": ["2015", "2014", "2013", "2012"],
  //   "C250 Sedan W205": ["2015", "2014", "2013", "2012"],
  //   "C300": ["2017", "2016", "2015"],
  //   "C350 Coupe C204": ["2015", "2014", "2013", "2012"],
  //   "C63 Amg Coupe C204": ["2015", "2014", "2013", "2012"],
  //   "Cla 250": ["2018", "2017", "2016", "2015", "2014"],
  //   "Clk": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998", "1997"],
  //   "Cls 500": ["2010", "2009", "2008", "2007"],
  //   E: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
  //   "E 300": ["2022", "2021", "2020", "2019", "2018", "2017"],
  //   "E 350": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
  //   "E 350 Coupe": ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
  //   "E 43 Amg": ["2018", "2017"],
  //   "E 450": ["2020", "2019"],
  //   "E 550": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
  //   "E Class W212": ["2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
  //   "E Class W212 S212 Sedan Wagon": ["2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
  //   "Gia 250": ["2020", "2019", "2018", "2017", "2016"],
  //   Glb: ["2024", "2023", "2022", "2021", "2020", "2019"],
  //   "Glb 5seats": ["2024", "2023", "2022", "2021", "2020", "2019"],
  //   "Glc 300": ["2022", "2021", "2020", "2019", "2018", "2017", "2016"],
  //   "Glc 350e": ["2022", "2021", "2020", "2019", "2018"],
  //   "Gle 350 5": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
  //   "Gle 450": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
  //   "Gle 580 5": ["2024", "2023", "2022", "2021", "2020"],
  //   "Glk 250": ["2015", "2014", "2013", "2012", "2011", "2010"],
  //   "Ml 350": ["2008", "2007", "2006"],
  //   "S-Class W220": ["2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
  //   "S320": ["1999", "1998", "1997", "1996", "1995", "1994", "1993", "1992"],
  //   S4: ["2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999", "1998"],
  //   S5: ["2013", "2012", "2011", "2010", "2009", "2008", "2007"],
  //   S6: ["2020", "2019", "2018", "2017", "2016", "2015", "2014"],
  //   "S-Class W220": ["2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"],
  //   "Slk 250": ["2015", "2014", "2013", "2012"],
  //   "Slk 300": ["2011", "2010"],
  //   Sprinter: ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
   
  // },

  Mitsubishi: {
Outlander: ["2024", "2023", "2022", "2021", "2020", "2019"],
"Outlander Sport 5": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
},

  Nissan: {
    Altima: ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],
    Armada: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    Frontier: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    Kicks: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    Leaf: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    Maxima: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    Murano: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    Pathfinder: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    Qashqai: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    Rogue: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "Rogue Sport": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    Sentra: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
    Titan: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "Titan Xd": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    Versa: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
  },
 
Oldsmobile:{
  "Cutlass": ["1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977"],
  "Delta 88": ["1988", "1987", "1986", "1985", "1984", "1983", "1982", "1981", "1980", "1979", "1978", "1977"],
  "Custom Cruiser": ["1996", "1995", "1994", "1993", "1992", "1991"],
  "442": ["1972", "1971", "1970", "1969", "1968"],
  "98": ["1979", "1968", "1967"],
  "88": ["1976", "1975", "1974", "1973", "1972", "1971"],
},

Peugeot:{
  "5008": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
},

Porsche: {
Cayenne: ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
Macan: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
Panamera: ["2016", "2015", "2014", "2013", "2012", "2011", "2010"],
},

Ram: {
  "1500": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
  "1500 Classic": ["2024", "2023", "2022", "2021", "2020", "2019"],
  "1501 Classic": ["2024", "2023", "2022", "2021", "2020", "2019"],
  "1502 Classic": ["2024", "2023", "2022", "2021", "2020", "2019"],
  "2500": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
  Rebel: ["2024", "2023", "2022", "2021", "2020", "2019"],
},

Special:{
  Order: ["All"],
},

Subaru: {
    Ascent: ["2024", "2023", "2022", "2021", "2020", "2019"],
    Forester: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
    Impreza: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    Legacy: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    Outback: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    Wrx: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    Xvcrosstrek: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
  },
   Suzuki: {
    "Grand Vitara": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
  },
   Tesla: {
    "CyberTruck": ["2024"],
    "3": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "S": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "X": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    "Y": ["2024", "2023", "2022", "2021", "2020", "2019"],
  },
   Toyota: {
    "4 Runner": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    "4 Runner 5 Passenger seating": ["2011"],
    "4 Runner 7 Passenger seating": ["2011"],
    "86": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
    Avalon: ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
    Bz4x: ["2024", "2023", "2022", "2021"],
    Camry: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    "Camry Hybrid": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
    Chr: ["2022", "2021", "2020", "2019", "2018", "2017"],
    "Corolla Cross": ["2024", "2023", "2022"],
    "Corolla Cross": ["2024", "2023", "2022"],
    "Corolla Cross Hybrid": ["2024"],
    "Corolla Hatchback": ["2024", "2023", "2022", "2021", "2020", "2019"],
    "Corolla Sedan": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Corolla Sedan Hybrid": ["2024", "2023", "2022", "2021", "2020"],
    "Crewmax": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "Cruiser": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Fj Cruiser": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    "Grand Highlander": ["2024"],
    "Highlander": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
    "Highlander 7 Passenger": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "Highlander 8 Passenger": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "Highlander Hybrid 7 Passenger": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "Highlander Hybrid 8 Passenger": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "Land Cruiser": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008"],
   Prado: ["2008", "2007", "2006", "2005", "2004"],
   Prius: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
   Prius: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
   "Prius 3": ["2015", "2014", "2013", "2012", "2011", "2010"],
   "Prius Prime": ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
   "Prius V": ["2017", "2016", "2015", "2014", "2013", "2012"],
   "Rav 4": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001"],
   "Rav 4 Hybrid": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
   Sequoia: ["2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013"],
   Sienna: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
   "Sienna 7 Passenger": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
   "Sienna 8 Passenger": ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
   Supra: ["2024", "2023", "2022"],
   Tacoma: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
   "Tacoma Double Cab": ["2022", "2021", "2020", "2019", "2018", "2017", "2016"],
   "Tacoma Double Cab With 5 Ft": ["2024"],
   Tundra: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
   "Tundra Crew": ["2013", "2012", "2011", "2010", "2009", "2008", "2007"],
   "Tundra Crew Cab": ["2022", "2021", "2020", "2019", "2018", "2017", "2016"],
   "Tundra Crew Cab Crewmax": ["2013", "2012", "2011", "2010", "2009", "2008", "2007"],
   "Tundra Double": ["2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
   "Tundra Double Cab": ["2024", "2023", "2022"],
   "Tundra Double Cab Crewmax": ["2024"],
   "Tundra Extended": ["2013", "2012", "2011", "2010", "2009", "2008", "2007"],
   "Tundra Regular": ["2013", "2012", "2011", "2010", "2009", "2008", "2007"],
   Venza: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
   "Venza Hybrid": ["2024", "2023", "2022", "2021"],
   Yaris: ["2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    
  },
Volkswagen:{
Arteon: ["2024", "2023", "2022", "2021", "2020", "2019"],
Atlas: ["2024", "2023", "2022", "2021", "2020", "2019", "2018"],
"E Golf": ["2019", "2018", "2017", "2016", "2015"],
"Golf Gti": ["2024", "2023", "2022"],
"Golf Alltrack": ["2019", "2018", "2017"],
"Golf Gti 4 Doors": ["2021", "2020", "2019", "2018", "2017", "2016", "2015"],
"Golf R 4 Doors": ["2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
"Golf Sportwagon": ["2019", "2018", "2017", "2016", "2015"],
"Golk Mk6 2 Doors": ["2012", "2011", "2010"],
"Golk Mk6 4 Doors": ["2014", "2013", "2012", "2011", "2010"],
"Golk Mk7 2 Doors": ["2016", "2015", "2014", "2013"],
"Golk Mk7 4 Doors": ["2021", "2020", "2019", "2018", "2017", "2016", "2015"],
Id4: ["2024", "2023", "2022", "2021"],
Jetta: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006"],
Passat: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012"],
Taos: ["2024", "2023", "2022"],
Tiguan: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009"],
Touareg: ["2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004"],
},

Volvo:{
  "C40 Recharge": ["2024", "2023", "2022"],
  S60: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"],
  Xc90: ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002"],

},



  
};

// Sample Object for two level filter. This sample data has filters for Car Make and Car Model. Last/Second filter should be an array.
let makeObject2 = {
  Acura: ["2015", "2014", "2013"],
  Accelera: ["175-70r13", "175-70r14", "175-70r15"],
  Nitto: ["165-60r13", "165-60r14", "165-60r15"],
};

// Sample Object for four level filter. This sample data has filters for Wheel Brand, Wheel Size, Lug Count, and Bolt Pattern. Last/Fourth filter should be an array.
let makeObject3 = {
  Acura: {
    ILX: {
      2014: ["4x100", "4x108"],
      2015: ["5x112", "5x114.3"],
    },
    Integra: {
      2015: ["5x100", "5x114.3", "5x120"],
    },
  },
  Enkei: {
    "17x8": {
      4: ["4x100", "4x108"],
      5: ["5x112", "5x114.3"],
    },
    "18x8.5": {
      5: ["5x100", "5x114.3", "5x120"],
    },
  },
  BBS: {
    "18x9": {
      5: ["5x112", "5x120"],
    },
    "19x8.5": {
      5: ["5x112", "5x114.3"],
    },
  },
  "OZ Racing": {
    "17x7.5": {
      4: ["4x100", "4x108"],
      5: ["5x100", "5x114.3"],
    },
    "18x8": {
      5: ["5x112", "5x120"],
    },
  },
  Forgestar: {
    "18x9": {
      5: ["5x114.3", "5x120"],
    },
    "19x10": {
      5: ["5x112", "5x120"],
    },
  },
  Vossen: {
    "20x9": {
      5: ["5x112", "5x120"],
    },
    "20x10.5": {
      5: ["5x114.3", "5x120"],
    },
  },
};
